import { ACTION_TYPE, REPORT_NAME } from "../../constant/reportType";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useState } from "react";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import * as Yup from 'yup';
import { getAllPipelineCategoriesList, setAllDataPipelinesCategoriesList } from "../../redux-toolkit/slices/allDataPipelinesCategoriesSlice";
import { useGetAllTemsSetMutation, useGetTermSetByIdMutation, useSaveTermSetMutation, useUpdateTermSetMutation } from "../../redux-toolkit/services/allTermSetService";
import { useGetAllValueChainCategoryMutation, useGetValueChainCategoryByAgentMasterIdMutation, useGetValueChainCategoryByIdMutation, useSaveValueChainCategoryMutation, useUpdateValueChainCategoryMutation } from "../../redux-toolkit/services/allValueChainCategoriesService";
import { useGetAllValueChainsByIdMutation, useGetAllValueChainsMutation, useSaveValueChainMutation, useUpdateValueChainMutation } from "../../redux-toolkit/services/allValueChainsService";
import { useGetTermByIdMutation, useSaveTermMutation, useUpdateTermMutation } from "../../redux-toolkit/services/allTermService";
import { useGetAllDataPipelinesCategoriesByIdMutation, useGetAllDataPipelinesCategoriesMutation, useGetAllDataPipelinesCategoriesWithPaginationMutation, useSaveDataPipelineCategoryMutation, useUpdateDataPipelineCategoryMutation } from "../../redux-toolkit/services/allDataPipelinesCategoriesService";
import { useGetAllDataPipelinesByIdMutation, useSaveDataPipelineMutation, useUpdateDataPipelineMutation } from "../../redux-toolkit/services/allDataPipelinesService";
import { useGetResultByTermsMutation } from "../../redux-toolkit/services/webSearchService";
import { getAllcountryDetail, setcountry } from "../../redux-toolkit/slices/countrySlice";
import { getFindStateByCountryNameDetail, setStates } from "../../redux-toolkit/slices/statesSlice";
import { useGetStateMutation } from "../../redux-toolkit/services/stateService";
import { useGetAllCountryMutation } from "../../redux-toolkit/services/countryService";
import { useGetDataRecordByIdMutation } from "../../redux-toolkit/services/allDataRecordsService";
import { getAllValueChainList, setAllValueChainList } from "../../redux-toolkit/slices/allValueChainsSlice";
import { getAllValueChainCategoriesList, setValueChainCategories } from "../../redux-toolkit/slices/allValueChainCategorySlice";
import { getAllTermSetList, setAllTemSetList, } from "../../redux-toolkit/slices/allTermSetSlice";
import { useGetAgentMasterByIdMutation, useGetAllAgentMasterMutation, useSaveAgentMasterMutation, useUpdateAgentMasterMutation } from "../../redux-toolkit/services/allAgentMasterService";
import { getAllAgentMasterList, setAllAgentMaster } from "../../redux-toolkit/slices/allAgentMasterSlice";
import { Modal } from "react-bootstrap";

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
    isCategory?: boolean;
};

const validationSchema = Yup.object().shape({
    percentageCompleted: Yup.number()
        // .required('Percentage is required')
        .min(0, 'Percentage must be at least 0')
        .max(100, 'Percentage cannot exceed 100'),
});

const MasterReportData = (props: Props) => {

    const dispatch = useDispatch();
    const token: any = getLocalStorageData("localUser").token;

    //states
    const [getByIdData, setGetByIdData]: any = useState([]);
    const [file, setFile]: any = useState<File | null>(null);
    const [imageBase64, setImageBase64] = useState() as any;
    const [newImage, setNewImage] = useState(null) as any;
    const [state, setState]: any = useState();
    const [country, setCountry]: any = useState();
    const [valueChainCat, setValueChainCat]: any = useState();
    const [valueChain, setValueChain]: any = useState();
    const [termSet, setTermSet]: any = useState();
    const [selectedCountry, setSelectedCountry]: any = useState();
    const [selectedState, setSelectedState]: any = useState();
    const [selectData, setSelectData]: any = useState();
    const [selectedCountryId, setSelectedCountryId] = useState(
        (props.actionType === ACTION_TYPE.UPDATE_ACTION &&
            props.reportName === REPORT_NAME.DATA_RECORD
            ? props.data.countryId
            : ""
        ));

    const [selectedStateId, setSelectedStateId] = useState(
        (props.actionType === ACTION_TYPE.UPDATE_ACTION &&
            props.reportName === REPORT_NAME.DATA_RECORD
            ? props.data.stateId
            : ""
        ));
    const [selectedValue, setSelectedValue] = useState("");
    const [selectedTermSet, setSelectedTermSet] = useState(
        props.actionType === ACTION_TYPE.UPDATE_ACTION &&
            props.reportName === REPORT_NAME.DATA_RECORD
            ? props.data.termsetId
            : ""
    );
    const [termSetName, setTermSetName] = useState();
    const [selectedValueChainCat, setSelectedValueChainCat] = useState(
        props.actionType === ACTION_TYPE.UPDATE_ACTION &&
            props.reportName === REPORT_NAME.DATA_RECORD
            ? props.data.categoryId
            : ""
    );

    const [valueChainCatName, setValueChainCatName] = useState();

    const [selectedValueChain, setSelectedValueChain] = useState(
        props.actionType === ACTION_TYPE.UPDATE_ACTION &&
            props.reportName === REPORT_NAME.DATA_RECORD
            ? props.data.valueChainId
            : ""
    );

    const [valueChainName, setValueChainName] = useState();

    //save
    const [saveAgentMaster, saveAgentMasterResponse] = useSaveAgentMasterMutation();
    const [saveValueChain, saveValueChainResponse] = useSaveValueChainMutation();
    const [saveValueChainCategory, saveValueChainCategoryResponse] = useSaveValueChainCategoryMutation();
    const [saveTerm, saveTermResponse] = useSaveTermMutation();
    const [saveTermSet, saveTermSetResponse] = useSaveTermSetMutation();
    const [saveDataPipelineCategory, saveDataPipelineCategoryResponse] = useSaveDataPipelineCategoryMutation();
    const [saveDataPipeline, saveDataPipelineResponse] = useSaveDataPipelineMutation();
    const [getResultByTerms, getResultByTermsResponse] = useGetResultByTermsMutation();

    //update
    const [updateAgentMaster, updateAgentMasterResponse] = useUpdateAgentMasterMutation();
    const [updateValueChain, updateValueChainResponse] = useUpdateValueChainMutation();
    const [updateValueChainCategory, updateValueChainCategoryResponse] = useUpdateValueChainCategoryMutation();
    const [updateTerm, updateTermResponse] = useUpdateTermMutation();
    const [updateTermSet, updateTermSetResponse] = useUpdateTermSetMutation();
    const [updateDataPipelineCategory, updateDataPipelineCategoryResponse] = useUpdateDataPipelineCategoryMutation();
    const [updateDataPipeline, updateDataPipelineResponse] = useUpdateDataPipelineMutation();

    //getById mutation
    const [getAgentMasterById, agentMasterByIdResponse] = useGetAgentMasterByIdMutation();
    const [getValueChainsById, valueChainsByIdResponse] = useGetAllValueChainsByIdMutation();
    const [getValueChainCategoriesById, valueChainCategoriesByIdResponse] = useGetValueChainCategoryByIdMutation();
    const [getTermById, getTermByIdResponse] = useGetTermByIdMutation();
    const [getTermSetById, getTermSetByIdResponse] = useGetTermSetByIdMutation();
    const [getDataPipelinesCategoriesById, dataPipelinesCategoiresByIdResponse] = useGetAllDataPipelinesCategoriesByIdMutation();
    const [getDataPipelinesById, dataPipelinesByIdResponse] = useGetAllDataPipelinesByIdMutation();
    const [getDataRecordById, getDataRecordByIdResponse] = useGetDataRecordByIdMutation();

    //getData
    const [getAllAgentMaster, getAllAgentMasterResponse] = useGetAllAgentMasterMutation();
    const [getAllTermSet, getAllTermSetResponse] = useGetAllTemsSetMutation();
    const [getAllValueChain, getAllValueChainResponse] = useGetAllValueChainsMutation();
    const [getState, getStateResponse] = useGetStateMutation();
    const [getCountry, getCountryResponse] = useGetAllCountryMutation();
    const [getValueChainCategories, valueChainCategoriesResponse] = useGetAllValueChainCategoryMutation();
    const [getAllDataPipelinesCategories, dataPipelinesCategoiresResponse] = useGetAllDataPipelinesCategoriesMutation();
    const [getValueChainCategoriesByAgent, getValueChainCategoriesByAgentResponse] = useGetValueChainCategoryByAgentMasterIdMutation();


    //Data
    const allAgentMaster: any = useAppSelector(getAllAgentMasterList);
    const allValueChain: any = useAppSelector(getAllValueChainList);
    const allValueChainCategories: any = useAppSelector(getAllValueChainCategoriesList);
    const allTermSets: any = useAppSelector(getAllTermSetList);
    const allDataPipelineCategories: any = useAppSelector(getAllPipelineCategoriesList);
    const allCountries: any = useAppSelector(getAllcountryDetail);
    const allStates: any = useAppSelector(getFindStateByCountryNameDetail);

    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.AGENT_MASTER) {
                getAgentMasterById({
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
                getAllAgentMaster({});
                getValueChainCategoriesById({
                    id: props?.data?.id,
                });
            }
            else if (props.reportName === REPORT_NAME.VALUE_CHAIN) {
                getValueChainsById({
                    id: props?.data?.id,
                });
            }
            else if (props.reportName === REPORT_NAME.TERM) {
                getAllTermSet({});
                getTermById({
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.TERM_SET) {
                getTermSetById({
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.DATA_PIPELINE_CATEGORY) {
                getDataPipelinesCategoriesById({
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.DATA_PIPELINE) {
                getAllDataPipelinesCategories({});
                getDataPipelinesById({
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.DATA_RECORD) {
                getDataRecordById({
                    id: props?.data?.id,
                });
            }
        } else if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            if (props.reportName === REPORT_NAME.DATA_RECORD) {
                getAllAgentMaster({})
                getAllTermSet({});
                getAllValueChain({});
                getValueChainCategories({});
                getCountry({});

            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
                getAllAgentMaster({});
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN) {
                getAllAgentMaster({});
                getValueChainCategories({ });
            }
            else if (props.reportName === REPORT_NAME.DATA_PIPELINE) {
                getAllDataPipelinesCategories({});
            }
            else if (props.reportName === REPORT_NAME.TERM) {
                getAllTermSet({});
            }
        }
    }, [props.reportName]);

    useEffect(() => {
        if (valueChainCategoriesResponse.isSuccess) {
            dispatch(setValueChainCategories(valueChainCategoriesResponse));
        } else if (valueChainCategoriesResponse.isError) {
            let response: any = valueChainCategoriesResponse.error;
            alertMessage(response, "error");
        }
    }, [valueChainCategoriesResponse.isSuccess, valueChainCategoriesResponse.isError]);

    useEffect(() => {
        if (dataPipelinesCategoiresResponse.isSuccess) {
            dispatch(setAllDataPipelinesCategoriesList(dataPipelinesCategoiresResponse));
        } else if (dataPipelinesCategoiresResponse.isError) {
            let response: any = dataPipelinesCategoiresResponse.error;
            alertMessage(response, "error");
        }
    }, [dataPipelinesCategoiresResponse.isSuccess, dataPipelinesCategoiresResponse.isError]);

    useEffect(() => {
        if (agentMasterByIdResponse.isSuccess) {
            setGetByIdData(agentMasterByIdResponse.data);
            setSelectedValue(agentMasterByIdResponse?.data?.categoryId)
        } else if (agentMasterByIdResponse.isError) {
            let response: any = agentMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [agentMasterByIdResponse.isSuccess, agentMasterByIdResponse.isError]);

    useEffect(() => {
        if (valueChainsByIdResponse.isSuccess) {
            getValueChainCategoriesByAgent({
                agentMasterId: valueChainsByIdResponse?.data?.agentMasterId,
            });
            setGetByIdData(valueChainsByIdResponse.data);
            setSelectedValue(valueChainsByIdResponse?.data?.categoryId)
        } else if (valueChainsByIdResponse.isError) {
            let response: any = valueChainsByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [valueChainsByIdResponse.isSuccess, valueChainsByIdResponse.isError]);

    useEffect(() => {
        if (valueChainCategoriesByIdResponse.isSuccess) {
            setGetByIdData(valueChainCategoriesByIdResponse.data);
        } else if (valueChainCategoriesByIdResponse.isError) {
            let response: any = valueChainCategoriesByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [valueChainCategoriesByIdResponse.isSuccess, valueChainCategoriesByIdResponse.isError]);

    useEffect(() => {
        if (getTermByIdResponse.isSuccess) {
            setGetByIdData(getTermByIdResponse.data);
            setSelectedValue(getTermByIdResponse?.data?.termsetid);
        } else if (getTermByIdResponse.isError) {
            let response: any = getTermByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [getTermByIdResponse.isSuccess, getTermByIdResponse.isError]);

    useEffect(() => {
        if (getTermSetByIdResponse.isSuccess) {
            setGetByIdData(getTermSetByIdResponse.data);
        } else if (getTermSetByIdResponse.isError) {
            let response: any = getTermSetByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [getTermSetByIdResponse.isSuccess, getTermSetByIdResponse.isError]);

    useEffect(() => {
        if (dataPipelinesCategoiresByIdResponse.isSuccess) {
            setGetByIdData(dataPipelinesCategoiresByIdResponse.data);
        } else if (dataPipelinesCategoiresByIdResponse.isError) {
            let response: any = dataPipelinesCategoiresByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [dataPipelinesCategoiresByIdResponse.isSuccess, dataPipelinesCategoiresByIdResponse.isError]);

    useEffect(() => {
        if (dataPipelinesByIdResponse.isSuccess) {
            setGetByIdData(dataPipelinesByIdResponse.data);
            setSelectedValue(dataPipelinesByIdResponse?.data?.pipelineCategoryId);
        } else if (dataPipelinesByIdResponse.isError) {
            let response: any = dataPipelinesByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [dataPipelinesByIdResponse.isSuccess, dataPipelinesByIdResponse.isError]);

    useEffect(() => {
        if (getDataRecordByIdResponse.isSuccess) {
            setGetByIdData(getDataRecordByIdResponse.data);
        } else if (getDataRecordByIdResponse.isError) {
            let response: any = getDataRecordByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [getDataRecordByIdResponse.isSuccess, getDataRecordByIdResponse.isError]);

    const handleClose = () => {
        props.setShow(false);
    };

    const fetchByAgentMastertId = (agentMasterId: any) => {
        if (props.reportName === REPORT_NAME.VALUE_CHAIN) {
            getValueChainCategoriesByAgent({
                agentMasterId: agentMasterId,
            });
        }

    }

    useEffect(() => {
        if (getValueChainCategoriesByAgentResponse.isSuccess) {
            setSelectData(getValueChainCategoriesByAgentResponse.data)
        }
        else if (getValueChainCategoriesByAgentResponse.isError) {
            let response: any = getValueChainCategoriesByAgentResponse?.error;
            alertMessage(response, "error");
        }

    }, [getValueChainCategoriesByAgentResponse.isSuccess, getValueChainCategoriesByAgentResponse.isError])

    const handleSubmit = (values: any) => {

        if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            if (props.reportName === REPORT_NAME.AGENT_MASTER) {
                const payload = {
                    name: values.name,
                    role: values.role,
                    function: values.function,
                    astra: values.astra
                };

                const formData = new FormData();
                formData.append('agentMaster', new Blob([JSON.stringify(payload)], { type: 'application/json' }));

                if (file) {
                    formData.append('image', file);
                }
                saveAgentMaster({
                    token: token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
                saveValueChainCategory({
                    token: token,
                    payload: {
                        isActive: true,
                        name: values.name,
                        agentMasterId: values.agentMasterId
                    },
                });
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN) {
                saveValueChain({
                    token: token,
                    payload: {
                        isActive: true,
                        categoryId: parseInt(selectedValue),
                        name: values.name,
                        agentMasterId: values.agentMasterId
                    },
                });
            } else if (props.reportName === REPORT_NAME.TERM) {
                saveTerm({
                    payload: {
                        isActive: true,
                        termsetid: parseInt(selectedValue),
                        name: values.name,
                    },
                });
            } else if (props.reportName === REPORT_NAME.TERM_SET) {
                saveTermSet({
                    payload: {
                        isActive: true,
                        name: values.name,
                    },
                });
            } else if (props.reportName === REPORT_NAME.DATA_PIPELINE_CATEGORY) {
                saveDataPipelineCategory({
                    payload: {
                        isActive: true,
                        name: values.name,
                    },
                });
            } else if (props.reportName === REPORT_NAME.DATA_PIPELINE) {
                saveDataPipeline({
                    payload: {
                        isActive: true,
                        pipelineCategoryId: parseInt(selectedValue),
                        name: values.name,
                    },
                });
            } else if (props.reportName === REPORT_NAME.DATA_RECORD) {
                getResultByTerms({
                    payload: {
                        datapipelineId: 1,
                        termsetId: parseInt(selectedTermSet),
                        country: selectedCountry,
                        state: selectedState,
                        district: values.district,
                        city: values.city,
                        pincode: values.pinCode,
                        valueChainId: parseInt(selectedValueChain),
                        valueChainName: valueChainName,
                        valueChainCategoryId: parseInt(selectedValueChainCat),
                        valueChainCategoryName: valueChainCatName,
                        termSetName: termSetName,
                        agentMasterId: parseInt(values.agentId),
                    },
                });
            }
        } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.AGENT_MASTER) {
                const payload = {
                    id: values.id,
                    name: values.name,
                    role: values.role,
                    function: values.function,
                    astra: values.astra,
                };

                const formData = new FormData();
                formData.append('agentMaster', new Blob([JSON.stringify(payload)], { type: 'application/json' }));

                if (file) {
                    formData.append('image', file);
                }

                updateAgentMaster({
                    id: props?.data?.id,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY) {
                updateValueChainCategory({
                    id: props?.data?.id,
                    payload: {
                        isActive: props.data.isActive,
                        id: props?.data?.id,
                        name: values.name,
                        agentMasterId: values.agentMasterId
                    },
                });
            } else if (props.reportName === REPORT_NAME.VALUE_CHAIN) {
                updateValueChain({
                    payload: {
                        isActive: props.data.isActive,
                        id: props.data.id,
                        categoryId: selectedValue,
                        name: values.name,
                        agentMasterId: values.agentMasterId
                    },
                });
            } else if (props.reportName === REPORT_NAME.TERM) {
                updateTerm({
                    id: props?.data?.id,
                    payload: {
                        isActive: props.data.isActive,
                        id: props.data.id,
                        termsetid: selectedValue,
                        name: values.name,
                    },
                });
            } else if (props.reportName === REPORT_NAME.TERM_SET) {
                updateTermSet({
                    id: props?.data?.id,
                    payload: {
                        isActive: props.data.isActive,
                        id: props.data.id,
                        name: values.name,
                    },
                });
            } else if (props.reportName === REPORT_NAME.DATA_PIPELINE_CATEGORY) {
                updateDataPipelineCategory({
                    payload: {
                        isActive: props.data.isActive,
                        id: props.data.id,
                        name: values.name,
                    },
                });
            } else if (props.reportName === REPORT_NAME.DATA_PIPELINE) {
                updateDataPipeline({
                    payload: {
                        isActive: props.data.isActive,
                        id: props.data.id,
                        pipelineCategoryId: parseInt(selectedValue),
                        name: values.name,
                    },
                });
            }
        }
    };

    useEffect(() => {
        if (saveAgentMasterResponse.isSuccess) {
            alertMessage("Agent Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveAgentMasterResponse.isError) {
            let response: any = saveAgentMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveAgentMasterResponse.isSuccess, saveAgentMasterResponse.isError]);

    useEffect(() => {
        if (updateAgentMasterResponse.isSuccess) {
            alertMessage("Agent Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateAgentMasterResponse.isError) {
            let response: any = updateAgentMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateAgentMasterResponse.isSuccess, updateAgentMasterResponse.isError]);

    //save value chain
    useEffect(() => {
        if (saveValueChainResponse.isSuccess) {
            alertMessage("Value Chain added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveValueChainResponse.isError) {
            let response: any = saveValueChainResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveValueChainResponse.isSuccess, saveValueChainResponse.isError]);

    //after update
    useEffect(() => {
        if (updateValueChainResponse.isSuccess) {
            alertMessage("Value Chain updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateValueChainResponse.isError) {
            let response: any = updateValueChainResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateValueChainResponse.isSuccess, updateValueChainResponse.isError]);

    //save value chain selectedValue
    useEffect(() => {
        if (saveValueChainCategoryResponse.isSuccess) {
            alertMessage("Value Chain Category added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveValueChainCategoryResponse.isError) {
            let response: any = saveValueChainCategoryResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveValueChainCategoryResponse.isSuccess, saveValueChainCategoryResponse.isError]);

    //update value chain selectedValue
    useEffect(() => {
        if (updateValueChainCategoryResponse.isSuccess) {
            alertMessage("Value Chain Category updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateValueChainCategoryResponse.isError) {
            let response: any = updateValueChainCategoryResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateValueChainCategoryResponse.isSuccess, updateValueChainCategoryResponse.isError]);

    useEffect(() => {
        if (saveTermResponse.isSuccess) {
            alertMessage("Term added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveTermResponse.isError) {
            let response: any = saveTermResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveTermResponse.isSuccess, saveTermResponse.isError]);

    useEffect(() => {
        if (updateTermResponse.isSuccess) {
            alertMessage("Term updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateTermResponse.isError) {
            let response: any = updateTermResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateTermResponse.isSuccess, updateTermResponse.isError]);

    useEffect(() => {
        if (saveTermSetResponse.isSuccess) {
            alertMessage("Term Set added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveTermSetResponse.isError) {
            let response: any = saveTermSetResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveTermSetResponse.isSuccess, saveTermSetResponse.isError]);

    useEffect(() => {
        if (updateTermSetResponse.isSuccess) {
            alertMessage("Term Set updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateTermSetResponse.isError) {
            let response: any = updateTermSetResponse?.error;
            alertMessage(response, "error");
            handleClose();
        }
    }, [updateTermSetResponse.isSuccess, updateTermSetResponse.isError]);

    // save datapipeline category
    useEffect(() => {
        if (saveDataPipelineCategoryResponse.isSuccess) {
            alertMessage("Data Pipeline Category added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveDataPipelineCategoryResponse.isError) {
            let response: any = saveDataPipelineCategoryResponse?.error;
            alertMessage("Error while adding", "error");
        }
    }, [saveDataPipelineCategoryResponse.isSuccess, saveDataPipelineCategoryResponse.isError]);

    //update datapipeline category
    useEffect(() => {
        if (updateDataPipelineCategoryResponse.isSuccess) {
            alertMessage("Data Pipeline Category updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateDataPipelineCategoryResponse.isError) {
            alertMessage("Error while adding", "error");
            handleClose();
        }
    }, [updateDataPipelineCategoryResponse.isSuccess, updateDataPipelineCategoryResponse.isError]);

    // save datapipeline
    useEffect(() => {
        if (saveDataPipelineResponse.isSuccess) {
            alertMessage("Data Pipeline added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveDataPipelineResponse.isError) {
            alertMessage("Error while adding", "error");
        }
    }, [saveDataPipelineResponse.isSuccess, saveDataPipelineResponse.isError]);

    //update datapipeline
    useEffect(() => {
        if (updateDataPipelineResponse.isSuccess) {
            alertMessage("Data Pipeline updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateDataPipelineResponse.isError) {
            alertMessage("Error while updating Data Pipeline", "error");
            handleClose();
        }
    }, [updateDataPipelineResponse.isSuccess, updateDataPipelineResponse.isError]);

    // save dataRecord
    useEffect(() => {
        if (getResultByTermsResponse.isSuccess) {
            alertMessage("Search Successfull", "success");
            props.setCall("Y");
            handleClose();
        } else if (getResultByTermsResponse.isError) {
            alertMessage("Error while searching", "error");
        }
    }, [getResultByTermsResponse.isSuccess, getResultByTermsResponse.isError]);

    useEffect(() => {
        if (allValueChainCategories && props.reportName === REPORT_NAME.VALUE_CHAIN) {
            const allValueChainCategoriesAsc = [...allValueChainCategories].sort((a, b) => a.id - b.id);
            setSelectData(allValueChainCategoriesAsc);
        } else if (allTermSets && props.reportName === REPORT_NAME.TERM) {
            const allTermSetsAsc = [...allTermSets].sort((a, b) => a.id - b.id);
            setSelectData(allTermSetsAsc);
        } else if (allDataPipelineCategories && props.reportName === REPORT_NAME.DATA_PIPELINE) {
            const allDataPipelineCategoriesAsc = [...allDataPipelineCategories].sort((a, b) => a.id - b.id);
            setSelectData(allDataPipelineCategoriesAsc);
        }
    }, [allValueChainCategories, allTermSets, allDataPipelineCategories]);


    useEffect(() => {
        if (getAllAgentMasterResponse.isSuccess) {
            dispatch(setAllAgentMaster(getAllAgentMasterResponse));
        }
        else if (getAllAgentMasterResponse.isError) {
            let response: any = getAllAgentMasterResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllAgentMasterResponse.isSuccess, getAllAgentMasterResponse.isError]);

    useEffect(() => {
        if (getAllValueChainResponse.isSuccess) {
            dispatch(setAllValueChainList(getAllValueChainResponse));
        } else if (getAllValueChainResponse.isError) {
            let response: any = getAllValueChainResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllValueChainResponse.isSuccess, getAllValueChainResponse.isError]);

    useEffect(() => {
        if (getAllTermSetResponse.isSuccess) {
            dispatch(setAllTemSetList(getAllTermSetResponse));
        } else if (getAllTermSetResponse.isError) {
            let response: any = getAllTermSetResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllTermSetResponse.isSuccess, getAllTermSetResponse.isError]);

    //getData responses
    useEffect(() => {
        if (getCountryResponse.isSuccess) {
            dispatch(setcountry(getCountryResponse));
        } else if (getCountryResponse.isError) {
            let response: any = getCountryResponse.error;
            alertMessage(response, "error");
        }
    }, [getCountryResponse.isSuccess, getCountryResponse.isError]);

    useEffect(() => {
        if (getStateResponse.isSuccess) {
            dispatch(setStates(getStateResponse));
        } else if (getStateResponse.isError) {
            let response: any = getStateResponse.error;
            alertMessage(response, "error");
        }
    }, [getStateResponse.isSuccess, getStateResponse.isError]);


    useEffect(() => {
        if (props.reportName === REPORT_NAME.DATA_RECORD) {
            if (allTermSets) {
                const allTermSetsAsc = [...allTermSets].sort((a, b) => a.id - b.id);
                setTermSet(allTermSetsAsc);
            }
            if (allValueChainCategories) {
                const allValueChainCategoriesAsc = [...allValueChainCategories].sort((a, b) => a.id - b.id);
                setValueChainCat(allValueChainCategoriesAsc);
            }
            if (allValueChain) {
                const allValueChainAsc = [...allValueChain].sort((a, b) => a.id - b.id);
                setValueChain(allValueChainAsc);
            }
            if (allCountries) {
                setCountry(allCountries);
            }
            if (allStates) {
                setState(allStates);
            }
        }
    }, [allTermSets, allValueChainCategories, allValueChain, allCountries, allStates]);


    const handleSelectChange = (event: any) => {
        setSelectedValue(event.target.value);
    };

    const handleSelectTermSet = (event: any) => {
        setSelectedTermSet(event.target.value);
        let object: any = termSet?.find((value: any) => value.id === parseInt(event.target.value));
        setTermSetName(object?.name);
    };

    const handleSelectValueChainCat = (event: any) => {
        setSelectedValueChainCat(event.target.value);
        let object: any = valueChainCat?.find((value: any) => value.id === parseInt(event.target.value));
        setValueChainName(object?.name);
    };

    const handleSelectValueChain = (event: any) => {
        setSelectedValueChain(event.target.value);
        let object: any = valueChain?.find((value: any) => value.id === parseInt(event.target.value));
        setValueChainCatName(object?.name);
    };

    const handleSelectCountry = (event: any) => {
        setSelectedCountryId(event.target.value);
        if (event) {
            getState({
                countryId: event.target.value,
            });
        }
        const countryName = allCountries.filter(
            (country: any) => country.id == event.target.value
        );
        setSelectedCountry(countryName[0].name);
    };

    const handleSelectState = (event: any) => {
        setSelectedStateId(event.target.value);
        const stateName = allStates.filter(
            (state: any) => state.id == event.target.value
        );
        setSelectedState(stateName[0].name);
    };

    // upload image...............................
    const imageHandler = (e: any) => {

        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setNewImage(reader.result);
                setImageBase64(null); // Clear the initial image if a new one is uploaded
            };
            reader.readAsDataURL(file);
        }

        const fileName = e.target.files[0].name;
        // setFileName(fileName)
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();

        if (extFile == "jpeg" || extFile == "jpg" || extFile == "svg" || extFile == "png") {
            setFile(e.target.files[0]);
        } else {
            alertMessage("Only jpeg, jpg, svg and png are allowed!", "error");
        }
    };

    return (
        <>
            <Modal
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            // style={{ marginTop: '20rem' }}
            // className={props.reportName === REPORT_NAME.TIME_SHEET ? "modal-xl" : "modal-lg"}
            // dialogClassName={"modal-90w"}
            >
                <Modal.Header closeButton>
                    {props.reportName === REPORT_NAME.DATA_RECORD ? (
                        <Modal.Title
                            className="fw-bold text-primary"
                            style={{ fontSize: "1rem" }}
                        >
                            Web Search
                        </Modal.Title>
                    ) : (
                        <Modal.Title
                            className="fw-bold text-primary"
                            style={{ fontSize: "1rem" }}
                        >
                            {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                            {props.reportName}
                        </Modal.Title>
                    )}
                </Modal.Header>
                <Modal.Body>

                    <Formik
                        validationSchema={props.reportName === REPORT_NAME.PROJECT_PHASE_ACTIVITY ? validationSchema : ""}
                        validateOnChange={true}
                        validateOnBlur={true}
                        enableReinitialize={true}
                        initialValues={
                            props.reportName === REPORT_NAME.DATA_RECORD
                                ? {
                                    agentId: "",
                                    termSetId: "",
                                    valueChainId: "",
                                    valueChainCatId: "",
                                    countryId: "",
                                    stateId: "",
                                    city: "",
                                    district: "",
                                    pinCode: "",
                                } : props.reportName === REPORT_NAME.AGENT_MASTER
                                    ? {
                                        name:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.name
                                                : "",
                                        role:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.role
                                                : "",
                                        function:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.function
                                                : "",
                                        astra:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.astra
                                                : "",
                                        image:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.image
                                                : "",
                                    } : props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY ? {
                                        name:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.name
                                                : "",
                                        agentMasterId:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.agentMasterId
                                                : "",
                                    } : props.reportName === REPORT_NAME.VALUE_CHAIN ? {
                                        agentMasterId:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.agentMasterId
                                                : "",
                                        select:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.categoryId
                                                : "",
                                        name:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.name
                                                : "",
                                    } : {
                                        name:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData && getByIdData.name
                                                : "",
                                        select:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION &&
                                                props.reportName === REPORT_NAME.TERM
                                                ? getByIdData && getByIdData.termsetid
                                                : props.reportName === REPORT_NAME.DATA_PIPELINE
                                                    ? getByIdData && getByIdData.pipelineCategoryId
                                                    : "",
                                    }}
                        onSubmit={handleSubmit}
                    >
                        {({ values, handleChange, setFieldValue, errors, touched, handleBlur }) => (
                            <Form>
                                {props.reportName === REPORT_NAME.DATA_RECORD ? (
                                    <div className=" p-2">
                                        {" "}
                                        <p>
                                            <div className="d-flex">
                                                <div>Agent</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <div className="w-100">
                                                <div className="pe-2">
                                                    <select
                                                        className="form-select form-select-sm w-100"
                                                        aria-label=".form-select-sm example"
                                                        name="agentId"
                                                        onChange={(e: any) => {
                                                            console.log(e.target.value)
                                                            setFieldValue("agentId", e.target.value);
                                                            const selectedAgentId = e.target.value;

                                                            // Filter value chain categories for selected agent
                                                            const filteredCategories = allValueChainCategories && allValueChainCategories.filter(
                                                                (category: any) => parseInt(category.agentMasterId) === parseInt(selectedAgentId)
                                                            );
                                                            console.log(filteredCategories, 'filteredCategories')
                                                            setValueChainCat(filteredCategories);
                                                        }}
                                                        value={values.agentId}
                                                        required
                                                    >
                                                        <option value="">
                                                            Select Agent
                                                        </option>
                                                        {allAgentMaster &&
                                                            allAgentMaster.map((itemType: any, index: any) => {
                                                                return (
                                                                    <option
                                                                        key={index.toString()}
                                                                        value={itemType.id}
                                                                    >
                                                                        {itemType.id} - {itemType.name}
                                                                    </option>
                                                                );
                                                            })}
                                                    </select>
                                                </div>
                                            </div>
                                        </p>
                                        <p>
                                            <div className="d-flex">
                                                <div>Value Chain Category</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <div className="w-100">
                                                <div className="pe-2">
                                                    <select
                                                        className="form-select form-select-sm w-100"
                                                        aria-label=".form-select-sm example"
                                                        onChange={handleSelectValueChainCat}
                                                        name="valueChainCatId"
                                                        value={selectedValueChainCat}
                                                        required
                                                    >
                                                        <option value="">
                                                            Select Value Chain Category
                                                        </option>
                                                        {valueChainCat &&
                                                            valueChainCat.map((itemType: any, index: any) => {
                                                                return (
                                                                    <option
                                                                        key={index.toString()}
                                                                        value={itemType.id}
                                                                    >
                                                                        {itemType.id} - {itemType.name}
                                                                    </option>
                                                                );
                                                            })}
                                                    </select>
                                                </div>
                                            </div>
                                        </p>
                                        <p>
                                            <div className="d-flex">
                                                <div> Value Chain</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <div className="w-100">
                                                <div className="pe-2">
                                                    <select
                                                        className="form-select form-select-sm w-100"
                                                        aria-label=".form-select-sm example"
                                                        onChange={handleSelectValueChain}
                                                        name="valueChainId"
                                                        value={selectedValueChain}
                                                        required
                                                    >
                                                        <option value="">Select Value Chain</option>
                                                        {valueChain &&
                                                            valueChain.map((itemType: any, index: any) => {
                                                                return (
                                                                    <option
                                                                        key={index.toString()}
                                                                        value={itemType.id}
                                                                    >
                                                                        {itemType.id} - {itemType.name}
                                                                    </option>
                                                                );
                                                            })}
                                                    </select>
                                                </div>
                                            </div>
                                        </p>
                                        <p>
                                            <div className="d-flex">
                                                <div>Term Set</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <div className="w-100">
                                                <div className="pe-2">
                                                    <select
                                                        className="form-select form-select-sm w-100"
                                                        aria-label=".form-select-sm example"
                                                        onChange={handleSelectTermSet}
                                                        name="termSetId"
                                                        value={selectedTermSet}
                                                        required
                                                    >
                                                        <option value="">Select Term Set</option>
                                                        {termSet &&
                                                            termSet.map((itemType: any, index: any) => {
                                                                return (
                                                                    <option
                                                                        key={index.toString()}
                                                                        value={itemType.id}
                                                                    >
                                                                        {itemType.id} - {itemType.name}
                                                                    </option>
                                                                );
                                                            })}
                                                    </select>
                                                </div>
                                            </div>
                                        </p>
                                        <p>
                                            Country
                                            <div className="pe-2">
                                                <select
                                                    className="form-select form-select-sm w-100"
                                                    aria-label=".form-select-sm example"
                                                    onChange={handleSelectCountry}
                                                    name="countryId"
                                                    value={selectedCountryId}
                                                >
                                                    <option value="">Select Country</option>
                                                    {country &&
                                                        country.map((itemType: any, index: any) => {
                                                            return (
                                                                <option
                                                                    key={index.toString()}
                                                                    value={itemType.id}
                                                                >
                                                                    {itemType.name}
                                                                </option>
                                                            );
                                                        })}
                                                </select>
                                            </div>
                                        </p>
                                        <p>
                                            State{" "}
                                            <div className="pe-2">
                                                <select
                                                    className="form-select form-select-sm w-100"
                                                    aria-label=".form-select-sm example"
                                                    onChange={handleSelectState}
                                                    name="stateId"
                                                    value={selectedStateId}
                                                >
                                                    <option value="">Select State</option>
                                                    {state &&
                                                        state.map((itemType: any, index: any) => {
                                                            // setSelectedStateId(itemType.id);
                                                            return (
                                                                <option
                                                                    key={index.toString()}
                                                                    value={itemType.id}
                                                                >
                                                                    {itemType.name}
                                                                </option>
                                                            );
                                                        })}
                                                </select>
                                            </div>
                                        </p>
                                        <p>
                                            City
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.city}
                                                name="city"
                                            // required
                                            />
                                        </p>
                                        <p>
                                            Remark
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.pinCode}
                                                name="pinCode"
                                            />
                                        </p>
                                    </div>
                                ) : (
                                    <>
                                        {props.reportName === REPORT_NAME.VALUE_CHAIN_CATEGORY || props.reportName === REPORT_NAME.VALUE_CHAIN ?
                                            <p>
                                                <div className="w-100">
                                                    <div className="d-flex">
                                                        <div>
                                                            Select Agent Master
                                                        </div>
                                                        <div style={{ color: "red" }}>*</div>
                                                    </div>
                                                    <div className="pe-2">
                                                        <select
                                                            className="form-select form-select-sm w-100"
                                                            aria-label=".form-select-sm example"
                                                            onChange={(e: any) => {
                                                                console.log(e.target.value)
                                                                setFieldValue("agentMasterId", e.target.value);

                                                                const selectedAgentId = e.target.value;
                                                                fetchByAgentMastertId(e.target.value)

                                                                // Filter value chain categories for selected agent
                                                                const filteredCategories = allValueChainCategories && allValueChainCategories.filter(
                                                                    (category: any) => parseInt(category.agentMasterId) === parseInt(selectedAgentId)
                                                                );
                                                                setSelectData(filteredCategories);
                                                            }}
                                                            name="agentMasterId"
                                                            value={values.agentMasterId}
                                                            required
                                                        >
                                                            <option value="">
                                                                Select Agent Master
                                                            </option>
                                                            {allAgentMaster &&
                                                                allAgentMaster.map((itemType: any, index: any) => {
                                                                    return (
                                                                        <option
                                                                            key={index.toString()}
                                                                            value={itemType.id}
                                                                        >
                                                                            {itemType.id} - {itemType.name}
                                                                        </option>
                                                                    );
                                                                })}
                                                        </select>
                                                    </div>
                                                </div>
                                            </p>
                                            : null}
                                        {!props.isCategory && (
                                            props.reportName !== REPORT_NAME.AGENT_MASTER && (
                                                <p>
                                                    <div className="w-100">
                                                        <div className="d-flex">
                                                            <div>
                                                                {" "}
                                                                Select{" "}
                                                                {(props.reportName === REPORT_NAME.VALUE_CHAIN ||
                                                                    props.reportName === REPORT_NAME.DATA_PIPELINE)
                                                                    ? "Category"
                                                                    : "Term Set"}
                                                            </div>
                                                            <div style={{ color: "red" }}>*</div>
                                                        </div>
                                                        <div className="pe-2">
                                                            <select
                                                                className="form-select form-select-sm w-100"
                                                                aria-label=".form-select-sm example"
                                                                onChange={handleSelectChange}
                                                                name="select"
                                                                value={selectedValue}
                                                                required
                                                            >
                                                                <option value="">
                                                                    Select{" "}
                                                                    {props.reportName === REPORT_NAME.DATA_PIPELINE ||
                                                                        props.reportName === REPORT_NAME.VALUE_CHAIN
                                                                        ? "Category"
                                                                        : "Term Set"}
                                                                </option>
                                                                {selectData &&
                                                                    selectData.map((itemType: any, index: any) => {
                                                                        return (
                                                                            <option
                                                                                key={index.toString()}
                                                                                value={itemType.id}
                                                                            >
                                                                                {itemType.id} - {itemType.name}
                                                                            </option>
                                                                        );
                                                                    })}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </p>
                                            )
                                        )}
                                        <p>
                                            <div className="d-flex">
                                                <div> {props.reportName} Name</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.name}
                                                name="name"
                                                required
                                            />
                                        </p>
                                    </>
                                )}
                                {props.reportName === REPORT_NAME.AGENT_MASTER ? (
                                    <div>
                                        <p>
                                            Role
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.role}
                                                name="role"
                                            />
                                        </p>
                                        <p>
                                            Function
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.function}
                                                name="function"
                                            />
                                        </p>
                                        <p>
                                            Astra
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.astra}
                                                name="astra"
                                            />
                                        </p>
                                        <div className="">
                                            <p>Upload Image</p>
                                            {imageBase64 && !newImage && (
                                                <img src={`data:image/png;base64,${imageBase64}`} alt="Current Logo" style={{ width: '50px', height: '50px' }} />
                                            )}
                                            {newImage && (
                                                <img src={newImage} alt="New Logo" style={{ width: '50px', height: '50px' }} />
                                            )}
                                            <input
                                                type="file"
                                                id="fileUpload"
                                                className="ms-2"
                                                onChange={(e: any) => {
                                                    imageHandler(e);
                                                    setFieldValue("image", e.target.files[0]);
                                                }}
                                            />
                                            <hr />
                                        </div>
                                    </div>
                                ) : null}
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        type="submit"
                                        className={`btn btn-primary btn-block mt-3 mx-2 btn-width`}
                                    >
                                        {props.actionType === ACTION_TYPE.ADD_ACTION
                                            ? "Save"
                                            : "Update"}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-block mt-3 mx-2 btn-width"
                                        onClick={handleClose}
                                    >
                                        Close
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal >
        </>
    );

};

export default MasterReportData